import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import MainHeaderLayout from 'components/@layout/MainHeaderLayout';
import routes from 'routes';
import { useSelector, shallowEqual } from 'react-redux';
import { getRedirectPath } from './util';

const AuthenticatedRouter = () => {
  const books: any = useSelector(({ entity }: any) => entity.workbooks, shallowEqual);
  const user: any = useSelector(({ user }: any) => user, shallowEqual);
  const location = useLocation() as any;
  const currentWorkbook: any = useSelector(({ app }: any) => app.currentWorkbook);
  const redirectPath = getRedirectPath({ user, books, location, currentWorkbook });
  return (
    <Routes>
      {(routes as any[]).map(({ component: Component, ...x }) => (
        <Route
          index={x.index}
          key={x?.getTitle ? x?.getTitle() : x.path}
          path={x.path}
          element={
            x.withMainLayout ? (
              <MainHeaderLayout {...x}>
                <Component />
              </MainHeaderLayout>
            ) : (
              <Component />
            )
          }
        >
          {x?.subRoutes &&
            x.subRoutes.map(({ component: Component, ...subRoute }) => (
              <Route
                index={subRoute.index}
                key={subRoute?.getTitle ? subRoute?.getTitle() : subRoute.path}
                path={subRoute.path}
                element={<Component />}
              />
            ))}
        </Route>
      ))}
      <Route path="*" element={<Navigate to={redirectPath ?? '/home'} replace />} />
    </Routes>
  );
};

export default AuthenticatedRouter;
